import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const ForgotPasswordPage = lazy(() => import('./ForgotPassowrdPage'));

const ForgotPasswordConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: AuthRoles.onlyGuest,

  routes: [
    {
      path: 'forgot-password',
      element: <ForgotPasswordPage />,
    },
  ],
};

export default ForgotPasswordConfig;
